import { formatDateForPicker } from '@/lib/cv-mapping';

// Tool cards echo whatever the tool was called with. Date arguments arrive as
// machine values ("2024-01-01T00:00:00.000Z"), and printing them raw made the
// "Updated experience" card read like a database dump (issue #269). Dates are
// rendered the way the CV editor renders them: "Jan 2024".

const DATE_FIELD_RE = /(^|[a-z])(date|at|from|until|since|expiry|expiration)$/i;

const ISO_LIKE_RE = /^\d{4}(-\d{1,2}(-\d{1,2})?)?([T ]\d{2}:\d{2}.*)?$/;

export function looksLikeDateField(field: string) {
  return DATE_FIELD_RE.test(field);
}

export function looksLikeDateValue(value: string) {
  return ISO_LIKE_RE.test(value.trim());
}

/** "2024-01-01T00:00:00.000Z" → "Jan 2024"; anything else is left alone. */
export function formatToolCardDate(value: string) {
  const formatted = formatDateForPicker(value);
  return formatted || value;
}

export function formatToolCardValue(value: unknown, field?: string): string {
  if (value == null) return '';
  if (typeof value === 'boolean') return value ? 'Yes' : 'No';
  if (typeof value === 'number') return String(value);

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (!trimmed) return '';
    // A bare year field ("2024") is only a date when the field says so; a
    // string like "2024" in `title` should stay as written.
    const isDate = looksLikeDateValue(trimmed)
      ? /[-T:]/.test(trimmed) || (field ? looksLikeDateField(field) : false)
      : false;
    return isDate ? formatToolCardDate(trimmed) : value;
  }

  if (Array.isArray(value)) {
    return value
      .map((entry) => formatToolCardValue(entry, field))
      .filter(Boolean)
      .join(', ');
  }

  return JSON.stringify(value);
}
